import { PromoterProfileModule } from '@/modules/promoters/shared/promoter-profile';
import { PROMOTERS_LIST_PAGE_SIZE } from '@/modules/promoters/shared/promoters-table-pagination';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  page: z.coerce.number().default(1),
  limit: z.coerce.number().default(PROMOTERS_LIST_PAGE_SIZE),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  txnType: z.string().optional(),
  txnStatus: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/promoters/$promoterId')({
  validateSearch: searchSchema,
  component: PromoterProfileModule,
});
